window.addEventListener("DOMContentLoaded",function(){
  
  // 获取具有类名为 "ufe-widget" 的元素
  var productForm = document.querySelector('product-form.product-form');
  var ufeWidget = document.querySelector('.ufe-widget');
  var utfProductPage = document.querySelector('.ufe-productPage-page');
  // 创建 MutationObserver 实例
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // 判断是否是子元素的 class 发生变化
      if (mutation.type === 'attributes') {
        // 重新绑定点击事件
        bindClickEvents();
      }
    });
  });
  
  // 配置观察器以监视子元素的 class 属性变化
  var config = { attributes: true, subtree: true };
  
  // 启动观察器，并传入目标节点和配置
  if(productForm){
    observer.observe(productForm, config);
  }
  
  // 初始绑定点击事件
  const ufeTestInterval = setInterval(function(){
    if(productForm){
      bindClickEvents();
      clearInterval(ufeTestInterval);
    }
  },1000)
  
})
// 绑定点击事件的函数
function bindClickEvents() {
  console.log("绑定点击事件");
  // 获取直接子元素
  var ufeWrapper = document.querySelector('.ufe-core.ufe-fbt .ufeWrapper');
  if(ufeWrapper){
    console.log("绑定点击事件 2");
    var ufeWrapperChildren = ufeWrapper.children;
    // 移除之前的点击事件监听器
      for (var i = 0; i < ufeWrapperChildren.length; i++) {
        var childElement = ufeWrapperChildren[i];
        childElement.removeEventListener('click', clickHandler);
      }
  
      // 循环为直接子元素添加点击事件
      for (var i = 0; i < ufeWrapperChildren.length; i++) {
        var childElement = ufeWrapperChildren[i];
        if(childElement.classList.contains('upsellWrapper') && i != -1){ //判断 i
          // 添加点击事件监听器
          childElement.addEventListener('click', clickHandler);
        }
      }
    
  }
}

// 点击事件的处理函数
function clickHandler() {
  //console.log("event.target.classList.value: "+event.target.classList.value.trim());
  //if(event.target.classList.contains('ufe-options')){
  console.log("checkbox click");
  if(event.target.classList.value != "fbt-chk-wrap ufe-checkbox" && event.target.classList.value.trim() != ""){
    targetDiv = this;
    nextSibling = targetDiv.nextElementSibling;
    resetUpsellWrapper();
    if(!nextSibling || !nextSibling.classList.contains('new-description-text')){
      //显示描述
      showDecriptionText(targetDiv);
    }
  }
}

function resetUpsellWrapper(){
    // 删除 ufeWrapper 下所有的具有 class 为 new-description-text 的元素
    var newDescriptionTextElements = document.querySelectorAll('.ufeWrapper .new-description-text');
    newDescriptionTextElements.forEach(function(element) {
      element.remove();
    });
    //重置样式
    var upsellWrapper = document.querySelectorAll('.ufeWrapper .upsellWrapper');
    upsellWrapper.forEach(function(element, index) {
        // 判断 i
      if(index != -1){
        element.style.setProperty('border-radius', '4px', 'important');
        element.style.setProperty('background-image', 'url(https://cdn.shopify.com/s/files/1/0790/2586/4977/files/dd82434d10b144c02543565c545ce38d.svg?v=1708424969)', 'important');
      }
    });
}

//显示描述函数
function showDecriptionText(element){
  var descriptionTextElement = element.querySelector('.ufe__description-text .ufe__description-text__full');
  if (descriptionTextElement) {
    var descriptionTextContent = descriptionTextElement.innerHTML;
    // 创建新的div元素
    var newDiv = document.createElement('div');
    newDiv.className = 'new-description-text';
    newDiv.innerHTML = "<p style='font-weight:bold;'>Features:</p>" + descriptionTextContent;
  
    // 在当前子元素后面插入新的div
    element.insertAdjacentElement('afterend', newDiv);
    // 强制浏览器重绘，以便应用初始状态
    newDiv.offsetHeight;

    element.style.setProperty('border-radius', '4px 4px 0 0', 'important');
    element.style.setProperty('background-image', 'url(https://cdn.shopify.com/s/files/1/0790/2586/4977/files/2392d48d60b8a431a5e112906ae44ac2.svg?v=1708424969)', 'important');
    // 设置新 div 的渐变效果
    newDiv.style.opacity = '1';
    newDiv.style.height = 'auto';
  } else {
    console.log('ufe__description-text does not exist in bundleWrapper');
  }
}